import { render, staticRenderFns } from "./hot.vue?vue&type=template&id=ce55e2f0&scoped=true&"
import script from "./hot.vue?vue&type=script&lang=js&"
export * from "./hot.vue?vue&type=script&lang=js&"
import style0 from "./hot.vue?vue&type=style&index=0&id=ce55e2f0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce55e2f0",
  null
  
)

export default component.exports